import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Use warn instead of error — unknown routes are expected/handled behavior,
    // not application errors. This prevents 404s from being surfaced as runtime errors.
    console.warn(
      "[NotFound] Route not found, showing 404 page for:",
      location.pathname
    );
  }, [location.pathname]);

  const handleReturnHome = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF8F3]">
      <div className="text-center px-6">
        <div className="flex items-center justify-center gap-4 mb-8">
          <div className="w-12 h-[1px] bg-[#C9A961]" />
          <span className="font-sans text-[10px] tracking-[0.4em] uppercase text-[#C9A961]">
            Zera Travel
          </span>
          <div className="w-12 h-[1px] bg-[#C9A961]" />
        </div>
        <h1 className="font-serif text-7xl md:text-9xl font-light text-[#1A3B5C] mb-4">404</h1>
        <p className="font-serif text-2xl md:text-3xl text-[#1A3B5C] font-light mb-4">
          Lost in Paradise
        </p>
        <p className="font-sans text-sm text-[#999] mb-10 max-w-md mx-auto">
          The destination you're looking for seems to have drifted away. Let us guide you back to extraordinary places.
        </p>
        <a
          href="/"
          onClick={handleReturnHome}
          className="inline-flex items-center gap-2 font-sans text-[11px] tracking-[0.25em] uppercase px-10 py-4 bg-[#1A3B5C] text-white hover:bg-[#2a5580] transition-all"
        >
          <ArrowLeft className="w-4 h-4" /> Return Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
